import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** Anzeige für unbekannte Adressen innerhalb der Anwendung. */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section>
      <h1>{t('notFound.title')}</h1>
      <p>
        <Link to="/">{t('notFound.back')}</Link>
      </p>
    </section>
  );
}
